import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Modal, Col, Card, Form, Button, Spinner, Row } from 'react-bootstrap';
import { RedContext } from '../../../context/connection/ContextRed';
import { AuthContext } from '../../../auth/AuthContext';
import { getEmiCl } from '../../../data/loopMap';
import { fetchConToken } from '../../../api/fetch';
import ServiceWiFi from './ServiceWiFi';
import ServiceFibra from './ServiceFibra';
import EditWifi from './EditWifi';
import EditarFibra from './EditarFibra';

const ModEditarService = ({ show, idS, onClose, callBk }) => {
    const { id } = useParams();

    let idR = atob(id);
    const [data, setData] = useState({});
    const { redState } = useContext(RedContext);
    const { auth } = useContext(AuthContext);
    const { roll } = auth;
    const [en, setEna] = useState(false);
    const [service, setService] = useState('');
    const [reload, setReload] = useState(false);
    const [emisorv, setEmi] = useState({ value: '', label: 'Ninguno' });
    const emis = getEmiCl(redState.emisores, 'nombre');
    useEffect(() => {
        getInfo();
    }, [idS, show, reload]);

    const getInfo = async () => {
        const res = await fetchConToken(`user/service/${idS}`);
        if (res.data) {
            setData(res.data);
            const { service, wifi } = res.data;
            setService(service?.ser_tipo);
            if (service?.ser_tipo === 'INALAMBRICO') {
                let nodo = emis.find((objeto) => objeto.value === wifi.id_emisor);
                if (nodo) setEmi(nodo);
            }
        }
    };
    useEffect(() => {
        roll === 'Técnico' ? setEna(true) : setEna(false);
    }, [roll]);
    const closeReset = () => {
        setReload(true);
        onClose();
        setTimeout(() => {
            setReload(false);
        }, 2000);
    };
    
    return (
        <Modal size="xl" show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Editar servicio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    {/* {JSON.stringify(item)} */}
                    <Col xl={4}>
                        {' '}
                        <Form.Group className="mb-3" controlId="validationCustom0">
                            <Form.Label>Tipo de servicio</Form.Label>

                            <Form.Select
                                value={service}
                                disabled={en}
                                required
                                onChange={(e) => setService(e.target.value)}>
                                <option value="">Seleccionar tipo de servicio</option>
                                <option value="INALAMBRICO">Inálambrico</option>
                                <option value="FIBRA">Fibra óptica</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>{' '}
                </Row>
                {service === 'INALAMBRICO' && (
                    <EditWifi
                        data={data}
                        red={true}
                        onClose={closeReset}
                        callBk={callBk}
                        nodo={emisorv}
                        reload={reload}
                    />
                )}
                {service === 'FIBRA' && (
                    <EditarFibra data={data} red={true} onClose={closeReset} callBk={callBk} reload={reload} />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ModEditarService;
